import React from 'react';
import styles from '../irlObservations2026.module.css';
import { DetailHeader, DetailTabs, EvidenceUploadButton, IrlCounts, ResponseComposer, UploadingEvidenceStatus } from './shared';

export default function IRL_No_Response({
    request,
    tab,
    onTab,
    onBack,
    onOpenAi,
    onCopy,
    copied,
    tabs,
    extraActions,
    onUpdateFields,
    responseDraft,
    onResponseDraft,
    onSubmitResponse,
    onSaveDraft,
    busy,
    onUploadEvidence,
    uploadingEvidence,
}) {
    const uploadDisabled = busy || uploadingEvidence;
    return (
        <>
            <DetailHeader kind="irl" item={request} onBack={onBack} onOpenAi={onOpenAi} onCopy={onCopy} copied={copied} extraActions={extraActions} onUpdateFields={onUpdateFields} busy={busy} />
            <DetailTabs tabs={tabs} tab={tab} onTab={onTab} counts={IrlCounts(request)} />
            <div className={styles.detailBody}>
                <div className={styles.wideInner} aria-busy={uploadingEvidence ? 'true' : undefined}>
                    <div className={styles.emptyState}>
                        <p className={styles.emptyTitle}>No response yet</p>
                        <p className={styles.emptyBody}>A response has not been submitted for this request.</p>
                    </div>
                    {uploadingEvidence ? <UploadingEvidenceStatus /> : null}
                    {onSubmitResponse && (
                        <ResponseComposer
                            value={responseDraft || ''}
                            onChange={onResponseDraft}
                            onSubmit={onSubmitResponse}
                            onSaveDraft={onSaveDraft}
                            busy={busy || uploadingEvidence}
                            extraAction={<EvidenceUploadButton onUpload={onUploadEvidence} disabled={uploadDisabled} />}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
